import { InfoField } from '@occc/ui-design-system';
import { ConstraintFragment } from '@occc/graphql';
import { getConstraintsByType } from '../constraints-section.utils';
import { formatEnum, formatValues } from '../../formatters';

export const BreakagePointRoundingConstraint = ({
  constraints,
}: {
  constraints: ConstraintFragment[];
}) => {
  const cst = getConstraintsByType('ConstraintRequiresTransactionVoucher', constraints);
  const values = cst.map((v) => formatEnum(v.breakagePointRounding));

  return <InfoField label='Point Rounding' value={formatValues(values)} />;
};
